export const UNIT_TYPES = [
  'EMPLOYEE', 'ONE_TIME_SETUP',
  'NOT_APPLICABLE', 'USER',
  'USER_LICENSE', 'CONNECTION',
  'REPORT', 'SMS_TEXT_MESSAGE',
  'DOCUMENT', 'LOCATION',
  'PARTICIPANT', 'MOBILE_USER',
  'EMPLOYEE_PER_WEEK', 'DATA_MANAGEMENT_USER',
  'CONNECTED_SYSTEMS', 'PROFESSIONAL_USER',
  'RECIPIENT', 'USAGE_FEE',
  'LICENSE', 'END_USER',
  'FORMS', 'ACTIVE_USERS',
  'ADDITIONAL_UNIT', 'ADDITIONAL_USER',
  'CERTIFICATION', 'ACTIVE_EMPLOYEE',
  'ADMINISTRATOR', 'SPECIALIST_USER',
  'GIGABYTE', 'CALLING_FEATURE',
  'WORD',
  'COMPANY',
  'PREMIUM',
  'PROJECT',
  'UNIT',
  'USER_100', 'USER',
  'HOUR', 'HOUR',
  'NBV_250K'
];

export const DURATION = {
  DAILY: { unit: 'day', length: 1, label: 'day' },
  MONTHLY: { unit: 'month', length: 1, label: 'month' },
  QUARTERLY: { unit: 'month', length: 3, label: 'quarter' },
  SIX_MONTHS: { unit: 'month', length: 6, label: '6 Mon' },
  YEARLY: { unit: 'year', length: 1, label: 'yr' },
  TWO_YEARS: { unit: 'year', length: 2, label: 'two yrs' },
  THREE_YEARS: { unit: 'year', length: 3, label: 'three yrs' },
  ONE_TIME: { unit: '', length: 0, label: 'one time' },
  ONE_TIME_SETUP: { unit: '', length: 0, label: '' }
};

export const SPECIAL_COSTS = {
  ONE_TIME_SETUP: {
    label: 'One Time Setup',
    showPriceInfo: false
  },
  NOT_APPLICABLE: {
    label: '', // Flat rate
    showPriceInfo: true
  }
};

export const ReferralSourceMappings = {
  'en-CA': 'CAN',
  'en-US': 'US',
  'fr-CA': 'CAN',
  'fr-FR': 'FR',
  'en-GB': 'UK',
  'nl-NL': 'DUTCH',
  'pt-BR': 'MCP'
};
